import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../layout/layout.vue'
import frontEndService from '../Services/frontEndService.js'
import helpers from '../helpers/filters'


const routes = [
    {
        path: '',
        name: 'Layout',
        component: Layout,
        children: [
            {
                path: '',
                name: 'HomePageDefault',
                redirect: to => {
                    return { path: `../layout/LogoutRedirect.vue` }
                }
            },


            {
                path: '/activityvendor',
                name: 'Activity Vendor Registration',
                component: () => import('@/views/VendorManagement/ActivityVendorForm.vue'),

            },
            {
                path: '/rewardpartner',
                name: 'Rewards Partner Registration',
                component: () => import('@/views/VendorManagement/RewardsVendorForm.vue'),

            }

        ]
    },
    {
        path: '/logoutRedirect/:origin',
        name: 'logoutRedirect',
        component: () => import('../layout/LogoutRedirect.vue')
    },
    {
        path: '/errorPage',
        name: 'errorPage',
        component: () => import('@/views/ErrorPage/errorPage.vue')
    }


];

//Global Arrays For Dynamic Menu
let HeaderNavlinks = []
let FooterNavlinks = []
const router = createRouter({
    history: createWebHistory(),
    routes, HeaderNavlinks, FooterNavlinks,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    const el = document.querySelector(to.hash)
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' })
                    }
                    resolve()
                }, 500)
            })
        }
        return { top: 0 }
    }
})


function createMenuItems(menuList) {
    return menuList.map(item => {
        const matchingRoute = routes[0].children.find(route => route.name === item.routeUrl);
        return {
            routeUrl: matchingRoute ? item.routeUrl : 'dynamicPage',
            displayText: item.displayText,
            childMenu: item.ChildMenu,
            params: matchingRoute ? null : { url: item.routeUrl }
        };
    });
}

async function setMenuItems(userId, companyId) {
    const response = await frontEndService.GetHeaderFooterData(userId, companyId, localStorage.getItem("LanguageId"));
    const HeaderFooterList = JSON.parse(Object.values(response.data));
    localStorage.setItem("HeaderFooterList", JSON.stringify(HeaderFooterList));
    HeaderNavlinks.push(JSON.stringify(createMenuItems(HeaderFooterList.HeaderMenuListing)));
    FooterNavlinks.push(JSON.stringify(createMenuItems(HeaderFooterList.FooterMenuListing)));
}

router.beforeEach(async (to, from, next) => {
    debugger;
    let companyDomainName = location.host;
    let companyUniqueName = to.path.split('/')[1] || to.path.substring(1);

    // Static company ID
    const staticCompanyId = '5C34DE86-5CAE-4637-81C2-7B0FAC506D51';

    // Set static company data
    await SetData(null, to.name, companyUniqueName);
    await setMenuItems(null, staticCompanyId);
    await beforeRouteHitMethods(to);

    if (to.hash == '' || to.hash == null) {
        window.scrollTo(0, 0);
    }

    await GetmetaData(to);
    document.title = `${localStorage.getItem('companyName')} | ${to.name}`;

    return next();
})

async function SetData(companyData, title, companyUniqueName) {
    localStorage.removeItem('companyId');
    localStorage.removeItem('companyName');
    localStorage.removeItem('comp-userId');
    localStorage.removeItem('companyURL');
    localStorage.removeItem('companyLogo');
    localStorage.removeItem('theme');
    localStorage.removeItem('companyAddress');
    localStorage.removeItem('showAssetViewIcon');
    localStorage.removeItem('domain');
    localStorage.removeItem('currency');
    localStorage.removeItem('TimeZone');
    localStorage.removeItem('CurrentCompDomain');

    // Static data
    const staticCompanyId = '5C34DE86-5CAE-4637-81C2-7B0FAC506D51';

    localStorage.setItem('companyId', staticCompanyId);
    localStorage.setItem('companyName', 'Tourist Point');
    localStorage.setItem('comp-userId', '');
    localStorage.setItem('companyURL', companyUniqueName);
    localStorage.setItem('companyLogo', '');
    localStorage.setItem('companySecondaryLogo', '');
    localStorage.setItem('theme', 'GolfCart');
    localStorage.setItem('currency', '');
    localStorage.setItem('CurrentCompDomain', location.host);
    localStorage.setItem('companyAddress', '');
    localStorage.setItem('showAssetViewIcon', '');

    if (localStorage.getItem('Language') == 'en' || localStorage.getItem('Language') == null) {
        localStorage.setItem("LanguageId", '364697eb-c5d6-44fa-8c08-ece45aed1844');
        localStorage.setItem("Language", 'en');
    } else {
        localStorage.setItem("LanguageId", 'cdf82d9b-07af-427e-9261-a3f45bc98f8f');
        localStorage.setItem("Language", 'spanish');
    }
    localStorage.setItem('TimeZone', '');

    setTimeout(function () {
        if (localStorage.getItem('theme') == 'GolfCart') {
            var getId = document.getElementById("golf_cart_not_visible")
            if (getId != null) {
                getId.classList.remove("page-wrapper");
            }
        }
    }, 4000);

    if (title == 'undefinded' || typeof title == "undefined") {
        title = ''
    }
    document.title = `Tourist Point | ${title}`;
    return true
}

async function beforeRouteHitMethods(to) {
    var compareElement = document.getElementById('comparisonblock');
    if (compareElement != null) {
        compareElement.classList.remove('open');
    }
    return
}

async function GetmetaData(to) {
    let metaModel = {
        PageTitle: to.name,
        PageUrl: to.href.replace('/', ''),
        companyId: localStorage.getItem('companyId')
    }
    const response = await frontEndService.GetdynamicMetadata(metaModel);
    debugger;
    if (response.data) {
        const { MetaKeyword, MetaDescription, MetaAuthor } = response.data;

        if (MetaKeyword) {
            document.getElementById('keyword')
                ?.setAttribute("content", MetaKeyword);
        }

        if (MetaDescription) {
            document.getElementById('description')
                ?.setAttribute("content", MetaDescription);
        }

        if (MetaAuthor) {
            document.getElementById('title')
                ?.setAttribute("content", MetaAuthor);
            document.title = MetaAuthor;
        }

        var screen = window.outerWidth;
        if (screen > 1080) {
            document.getElementById('viewport')
                ?.setAttribute("content", "width=device-width,initial-scale=1");
        } else {
            document.getElementById('viewport')
                ?.setAttribute("content", "width=device-width,initial-scale=1, user-scalable=no");
        }
    }
}

export default router